
import {defineComponent} from 'vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
import {ICON_TYPES} from './types';
import type {ButtonType} from './types';
import {TYPE_BOOTSTRAP, TYPES} from '../Icon/types';

export default defineComponent({
  name: 'OxdIconButton',

  components: {
    'oxd-icon': Icon,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    withContainer: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayType: {
      type: String,
      required: false,
      default: null,
      validator: function (value: ButtonType) {
        return !value || ICON_TYPES.indexOf(value) !== -1;
      },
    },
    iconType: {
      type: String,
      required: false,
      default: TYPE_BOOTSTRAP,
      validator: (value: string) => {
        return TYPES.indexOf(value) !== -1;
      },
    },
  },

  emits: ['click'],

  computed: {
    classes(): object {
      return {
        'oxd-icon-button': true,
        [`oxd-icon-button--${this.displayType}`]: Boolean(this.displayType),
      };
    },
  },

  methods: {
    onClick(e: Event) {
      e.preventDefault();
      this.$emit('click', e);
    },
  },
});
